import { getAbTestV2 } from 'dibs-buyer-layout/exports/clientABTestV2';

export const CHECKOUT_CANCELATION_POLICY_TEST = 'buyerCancelationPolicy';

export const isCheckoutCancelationPolicyVariant = (): boolean =>
    getAbTestV2(CHECKOUT_CANCELATION_POLICY_TEST)?.variant === 'variant';
